import React from "react";
import { Link } from "react-router-dom";

export default function AdminHome() {
  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold">Admin Dashboard</h1>
      <div className="grid gap-3 md:grid-cols-3">
        <Link to="/admin/slots" className="p-4 border rounded-xl hover:bg-gray-50 block">Manage Slots</Link>
        <Link to="/admin/rooms" className="p-4 border rounded-xl hover:bg-gray-50 block">Manage Rooms</Link>
        <Link to="/admin/assign" className="p-4 border rounded-xl hover:bg-gray-50 block">Assign Seats</Link>
        <Link to="/admin/volunteers" className="p-4 border rounded-xl hover:bg-gray-50 block">Volunteers</Link>
        <Link to="/admin/teams" className="p-4 border rounded-xl hover:bg-gray-50 block">Teams</Link>
        <Link to="/admin/admins" className="p-4 border rounded-xl hover:bg-gray-50 block">Admins</Link>
        <Link to="/admin/analytics" className="p-4 border rounded-xl hover:bg-gray-50 block">Analytics</Link>
      </div>
    </div>
  );
}
